/* =========================================================
   Affiche SKI — le profil de descente, la station, le slalom, la journée,
   la pente.
   API : SNSkDescente.render(data, opts) -> string SVG
     data : { mode, titre, kicker, club, lieu, joueur, equipe,
              mode 'descente' → p1..p8 (« 2.4|1850 ») : km parcourus, altitude
              mode 'station'  → vert, bleu, rouge, noir, s1..s3
              mode 'slalom'   → portes, manche1, manche2, s1..s3
              mode 'journee'  → t1..t6 (« Valeur|Libellé »)
              mode 'pente'    → degres, l1..l6 (« Libellé|valeur ») }
     opts : { palette }

   CE QUI N'EST PAS AFFIRMÉ. La couleur d'une piste n'est PAS adossée à un
   seuil de pente en France — c'est la station qui classe. L'Autriche
   (ÖNORM S 4610), l'Allemagne et l'Italie, elles, normalisent des seuils.
   L'affiche « station » se contente donc de COMPTER les pistes par couleur,
   sans jamais annoncer de pourcentage réglementaire.

   La conversion degrés → pourcentage, elle, est de la trigonométrie : elle est
   calculée, et une pente à 50 degrés vaut bien 119 %, pas « moins de 100 % ».

   Auto-suffisant (aucun fetch, aucune image, aucun aléa) → re-render serveur.
   ========================================================= */
(function () {
  const PW = 800, PH = 1066, MX = 64;

  const PALETTES = {
    neige:  { label:'Neige',  bg:'#F2F5F7', ink:'#16242E', muted:'#7B8B96', accent:'#C2410C', line:'#DDE4E8', card:'#FFFFFF', roche:'#CBD6DC' },
    nuit:   { label:'Nuit',   bg:'#0C1F33', ink:'#F1F5F8', muted:'#8399AC', accent:'#F2A73B', line:'#1B3550', card:'#132940', roche:'#1B3550' },
    sapin:  { label:'Sapin',  bg:'#12251E', ink:'#F0F4F0', muted:'#8AA79A', accent:'#F2A73B', line:'#213B31', card:'#1A3129', roche:'#213B31' },
    aube:   { label:'Aube',   bg:'#2B1E2C', ink:'#F6EFF3', muted:'#AE95AB', accent:'#F2A73B', line:'#443048', card:'#372639', roche:'#443048' },
  };
  /* Les quatre couleurs de piste du système français. Ce sont des LIBELLÉS,
     pas des seuils : aucune norme française n'attache un pourcentage de pente
     à une couleur. */
  const PISTES = [
    ['vert',  'Vertes', '#2E9E4F'],
    ['bleu',  'Bleues', '#2E6DA4'],
    ['rouge', 'Rouges', '#D64545'],
    ['noir',  'Noires', '#1D1D1B'],
  ];

  const esc = s => String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  const up = s => String(s == null ? '' : s).toUpperCase();
  /* Séparateur décimal français : 20,2 km et non 20.2 km. */
  const fr = n => String(n).replace('.', ',');
  const num = s => { const m = String(s == null ? '' : s).replace(',', '.').replace(/\s/g, '').match(/-?\d+(\.\d+)?/); return m ? parseFloat(m[0]) : null; };
  const fit = (t, maxW, maxS, cwf, ls, minS) => { const n = String(t).length || 1; minS = minS || 12;
    for (let s = maxS; s > minS; s -= 1) if (n * (cwf * s + ls) <= maxW) return s; return minS; };
  const T = (x,y,size,fill,txt,o) => { o = o || {};
    return `<text x="${x}" y="${y}" font-family="${o.f||'Sora'}" font-size="${size}" font-weight="${o.w||600}" fill="${fill}"`
      + (o.ls?` letter-spacing="${o.ls}"`:'') + ` text-anchor="${o.a||'middle'}"` + (o.op?` opacity="${o.op}"`:'') + `>${txt}</text>`; };

  function stats(p, items, y) {
    const it = (items || []).filter(x => x && String(x[0] || '').trim());
    if (!it.length) return '';
    const x0 = 54, w = (PW - 2*x0) / it.length;
    let s = `<line x1="${x0}" y1="${y-34}" x2="${PW-x0}" y2="${y-34}" stroke="${p.line}" stroke-width="1.5"/>`;
    it.forEach((c, i) => {
      const cc = x0 + w*i + w/2;
      if (i) s += `<line x1="${(x0+w*i).toFixed(0)}" y1="${y-14}" x2="${(x0+w*i).toFixed(0)}" y2="${y+34}" stroke="${p.line}" stroke-width="1.5"/>`;
      s += T(cc, y+6, fit(c[0], w-24, 36, 0.56, 0, 15), p.ink, esc(c[0]), { f:'Oswald', w:700 })
        + T(cc, y+30, 12, p.muted, esc(up(c[1])), { w:600, ls:2.5 });
    });
    return s;
  }
  function troisValeurs(p, data, y, defaut) {
    const perso = [1, 2, 3].map(i => {
      const raw = String(data['s' + i] || '').trim(); if (!raw) return null;
      const [v, l] = raw.split('|').map(s => (s || '').trim());
      return v ? [v, l || ''] : null;
    });
    return stats(p, perso.some(Boolean) ? perso.filter(Boolean) : (defaut || []), y);
  }

  /* Filigrane : une paire de skis, avec sa ligne de cote. C'était le manque
     le plus criant — aucune des cinq affiches de ski ne montrait un ski. */
  function filigrane(p) {
    const cy = 566, H = 520, y0 = cy - H / 2, y1 = cy + H / 2;
    const wS = H * 0.050, wP = H * 0.031, wT = H * 0.044, e = H * 0.082;
    const un = ax => `<path d="M ${ax} ${y0.toFixed(1)}`
      + ` Q ${(ax + wS).toFixed(1)} ${(y0 + H * 0.05).toFixed(1)} ${(ax + wS).toFixed(1)} ${(y0 + H * 0.13).toFixed(1)}`
      + ` Q ${(ax + wP).toFixed(1)} ${(y0 + H * 0.40).toFixed(1)} ${(ax + wP).toFixed(1)} ${(y0 + H * 0.56).toFixed(1)}`
      + ` Q ${(ax + wT).toFixed(1)} ${(y0 + H * 0.84).toFixed(1)} ${(ax + wT).toFixed(1)} ${(y0 + H * 0.94).toFixed(1)}`
      + ` Q ${(ax + wT).toFixed(1)} ${y1.toFixed(1)} ${(ax + wT * 0.5).toFixed(1)} ${y1.toFixed(1)}`
      + ` L ${(ax - wT * 0.5).toFixed(1)} ${y1.toFixed(1)}`
      + ` Q ${(ax - wT).toFixed(1)} ${y1.toFixed(1)} ${(ax - wT).toFixed(1)} ${(y0 + H * 0.94).toFixed(1)}`
      + ` Q ${(ax - wT).toFixed(1)} ${(y0 + H * 0.84).toFixed(1)} ${(ax - wP).toFixed(1)} ${(y0 + H * 0.56).toFixed(1)}`
      + ` Q ${(ax - wP).toFixed(1)} ${(y0 + H * 0.40).toFixed(1)} ${(ax - wS).toFixed(1)} ${(y0 + H * 0.13).toFixed(1)}`
      + ` Q ${(ax - wS).toFixed(1)} ${(y0 + H * 0.05).toFixed(1)} ${ax} ${y0.toFixed(1)} Z" fill="${p.ink}"/>`;
    return `<g opacity="0.055">${un(400 - e)}${un(400 + e)}</g>`;
  }

  function render(data, opts) {
    data = data || {}; opts = opts || {};
    const p = PALETTES[opts.palette] || PALETTES.neige;
    const mode = String(data.mode || 'descente').toLowerCase();
    const cx = PW / 2;

    const DEF = { descente: 'LA DESCENTE', station: 'MA STATION', slalom: 'LE SLALOM', journee: 'LA JOURNÉE', pente: 'LA PENTE' };
    const titre = up(data.titre) || DEF[mode] || 'LA DESCENTE';
    const ts = fit(titre, 690, 74, 0.54, 2, 34);
    const kicker = up(data.kicker) || up(data.club) || 'SKI';
    const sous = [up(data.club), up(data.lieu)].filter(Boolean).join(' · ');

    let corps = '', barre = '', pied = 0;

    if (mode === 'descente') {
      /* Le profil est tracé sur les points relevés, jamais reconstitué : la
         courbe relie ce que le client saisit, sans lisser. */
      const l = [];
      for (let i = 1; i <= 8; i++) {
        const raw = String(data['p' + i] || '').trim(); if (!raw) continue;
        const [a, b] = raw.split('|').map(x => (x || '').trim());
        const km = num(a), alt = num(b);
        if (km != null && alt != null && km >= 0) l.push({ km, alt });
      }
      l.sort((a, b) => a.km - b.km);
      if (l.length >= 2) {
        const X0 = MX + 52, X1 = PW - MX - 10, Y0 = 330, Y1 = 830;
        const kmMax = Math.max.apply(null, l.map(r => r.km)) || 1;
        const aMin = Math.min.apply(null, l.map(r => r.alt)), aMax = Math.max.apply(null, l.map(r => r.alt));
        const pas = (aMax - aMin) <= 300 ? 100 : (aMax - aMin) <= 800 ? 200 : 500;
        const bas = Math.floor(aMin / pas) * pas, haut = Math.ceil(aMax / pas) * pas;
        const px = km => X0 + (X1 - X0) * (km / kmMax);
        const py = a => Y1 - (Y1 - Y0) * (a - bas) / Math.max(1, haut - bas);
        for (let a = bas; a <= haut + 0.001; a += pas) {
          const y = py(a);
          corps += `<line x1="${X0}" y1="${y.toFixed(1)}" x2="${X1}" y2="${y.toFixed(1)}" stroke="${p.line}" stroke-width="1.2"/>`
            + T(X0 - 12, y + 5, 12, p.muted, `${a} M`, { w:600, ls:1.2, a:'end' });
        }
        /* la montagne sous la courbe */
        corps += `<path d="M ${px(l[0].km).toFixed(1)} ${Y1.toFixed(1)} `
          + l.map(r => `L ${px(r.km).toFixed(1)} ${py(r.alt).toFixed(1)}`).join(' ')
          + ` L ${px(l[l.length-1].km).toFixed(1)} ${Y1.toFixed(1)} Z" fill="${p.roche}" opacity="0.9"/>`;
        corps += `<polyline points="${l.map(r => `${px(r.km).toFixed(1)},${py(r.alt).toFixed(1)}`).join(' ')}" fill="none" stroke="${p.accent}" stroke-width="3.5" stroke-linejoin="round" stroke-linecap="round"/>`;
        for (const r of l) corps += `<circle cx="${px(r.km).toFixed(1)}" cy="${py(r.alt).toFixed(1)}" r="4.5" fill="${p.bg}" stroke="${p.accent}" stroke-width="2.5"/>`;
        const depart = l[0], arrivee = l[l.length - 1];
        corps += `<circle cx="${px(depart.km).toFixed(1)}" cy="${py(depart.alt).toFixed(1)}" r="8" fill="${p.accent}"/>`
          + T(px(depart.km), py(depart.alt) - 18, 17, p.ink, `${depart.alt} M`, { f:'Oswald', w:700, a: depart.km < kmMax * 0.15 ? 'start' : 'middle' })
          + T(px(arrivee.km), py(arrivee.alt) + 26, 15, p.muted, `${arrivee.alt} M`, { f:'Oswald', w:700, a:'end' })
          + T((X0 + X1) / 2, Y1 + 44, 11.5, p.muted, `${fr(kmMax)} KM DE DESCENTE · RELEVÉS DE LA TRACE`, { w:600, ls:2.6 });
        barre = stats(p, [[`${Math.round(aMax - aMin)} m`, 'Dénivelé'], [`${fr(kmMax)} km`, 'Distance'],
          [`${aMax} m`, 'Point le plus haut']], 962);
      } else corps = T(cx, 600, 19, p.muted, 'DEUX POINTS SUFFISENT : LE KILOMÈTRE, PUIS L’ALTITUDE', { w:600, ls:1.4 });
      pied = 1030;

    } else if (mode === 'station') {
      /* On COMPTE les pistes par couleur. Aucune pente n'est annoncée : en
         France la couleur relève du classement de la station, pas d'un seuil. */
      const l = PISTES.map(([k, lab, col]) => [lab, col, Math.max(0, parseInt(String(data[k] || ''), 10) || 0)]);
      const total = l.reduce((a, x) => a + x[2], 0);
      const maxi = Math.max.apply(null, l.map(x => x[2])) || 1;
      const X0 = MX + 118, X1 = PW - MX - 76, y0 = 356, pas = 118;
      l.forEach(([lab, col, n], i) => {
        const y = y0 + i * pas;
        corps += `<circle cx="${(MX + 42).toFixed(1)}" cy="${y.toFixed(1)}" r="21" fill="${col}" stroke="${p.ink}" stroke-width="${col === '#1D1D1B' ? 2 : 0}"/>`
          + T(MX + 42, y + 40, 11.5, p.muted, up(lab), { w:600, ls:2 })
          + `<rect x="${X0}" y="${(y - 17).toFixed(1)}" width="${Math.max(4, (X1 - X0) * n / maxi).toFixed(1)}" height="34" rx="8" fill="${col}" opacity="0.92"/>`
          + T(PW - MX, y + 12, 34, p.ink, String(n), { f:'Oswald', w:700, a:'end' });
      });
      corps += T(cx, y0 + 3 * pas + 92, 11.5, p.muted, `${total} PISTES BALISÉES`, { w:600, ls:3 });
      barre = troisValeurs(p, data, 968, [[String(total), 'Pistes'], ['—', 'Altitude'], ['—', 'Remontées']]);
      pied = 1030;

    } else if (mode === 'slalom') {
      /* Tracé SCHÉMATIQUE : les piquets sont figurés en quinconce sur la
         pente. Aucun écartement réglementaire n'est représenté ni annoncé —
         les cotes FIS dépendent de la discipline et du niveau de course. */
      const n = Math.max(4, Math.min(24, parseInt(String(data.portes || '12'), 10) || 12));
      const X = cx, Y0 = 320, Y1 = 812, amp = 150;
      const yp = i => Y0 + (Y1 - Y0) * i / (n - 1);
      const xp = i => X + (i % 2 ? 1 : -1) * amp * (0.55 + 0.45 * Math.abs(Math.sin(i * 1.1)));
      corps = `<path d="M ${X} ${(Y0 - 18).toFixed(1)} `
        + Array.from({ length: n }, (_, i) => `L ${xp(i).toFixed(1)} ${yp(i).toFixed(1)}`).join(' ')
        + ` L ${X} ${(Y1 + 18).toFixed(1)}" fill="none" stroke="${p.accent}" stroke-width="2.5" stroke-dasharray="8 7" opacity="0.85"/>`;
      for (let i = 0; i < n; i++) {
        const x = xp(i), y = yp(i), rouge = i % 2 === 0;
        const c = rouge ? '#D64545' : '#2E6DA4';
        corps += `<line x1="${(x - 22).toFixed(1)}" y1="${y.toFixed(1)}" x2="${(x + 22).toFixed(1)}" y2="${y.toFixed(1)}" stroke="${c}" stroke-width="2"/>`
          + `<circle cx="${(x - 22).toFixed(1)}" cy="${y.toFixed(1)}" r="5" fill="${c}"/>`
          + `<circle cx="${(x + 22).toFixed(1)}" cy="${y.toFixed(1)}" r="5" fill="${c}"/>`;
      }
      const m1 = String(data.manche1 || '').trim(), m2 = String(data.manche2 || '').trim();
      corps += T(cx, 866, 11.5, p.muted, `${n} PORTES · TRACÉ SCHÉMATIQUE`, { w:600, ls:2.8 });
      barre = troisValeurs(p, data, 968, [[esc(m1) || '—', '1re manche'], [esc(m2) || '—', '2e manche'], [String(n), 'Portes']]);
      pied = 1030;

    } else if (mode === 'journee') {
      const bl = [];
      for (let i = 1; i <= 6; i++) {
        const raw = String(data['t' + i] || '').trim(); if (!raw) continue;
        const [v, lab] = raw.split('|').map(x => (x || '').trim());
        if (v && lab) bl.push([v, lab]);
      }
      if (bl.length) {
        const cols = bl.length <= 4 ? 2 : 3, rangs = Math.ceil(bl.length / cols);
        const bw = (PW - 2*MX - (cols-1)*16) / cols, bh = Math.min(180, 560 / rangs);
        bl.forEach((b, i) => {
          const c = i % cols, r = Math.floor(i / cols);
          const x = MX + c * (bw + 16), y = 340 + r * (bh + 16);
          corps += `<rect x="${x.toFixed(1)}" y="${y.toFixed(1)}" width="${bw.toFixed(1)}" height="${bh.toFixed(1)}" rx="16" fill="${p.card}"/>`
            + T(x + bw/2, y + bh*0.60, fit(b[0], bw - 28, 58, 0.56, 0, 22), p.ink, esc(b[0]), { f:'Oswald', w:700 })
            + T(x + bw/2, y + bh*0.82, 13, p.muted, esc(up(b[1])), { w:600, ls:2 });
        });
      } else corps = T(cx, 600, 19, p.muted, 'FORMAT : LA VALEUR, UNE BARRE VERTICALE, SON LIBELLÉ', { w:600, ls:1.5 });
      barre = troisValeurs(p, data, 976, null);
      pied = 1032;

    } else { /* pente */
      /* LA PENTE, dessinée à son vrai angle, et le pourcentage CALCULÉ.
         100 % vaut 45 degrés — et au-delà de 45 degrés une pente dépasse
         allègrement 100 %, ce qui est exactement le cas des couloirs dont
         parle cette affiche. */
      const deg = Math.max(1, Math.min(89, num(data.degres) || 38));
      const pct = Math.round(Math.tan(deg * Math.PI / 180) * 100);
      const X0 = MX + 40, Y1 = 700, base = PW - 2*MX - 80;
      const h = Math.min(340, base * Math.tan(deg * Math.PI / 180));
      const w = h / Math.tan(deg * Math.PI / 180);
      corps = `<path d="M ${X0} ${Y1} L ${(X0 + w).toFixed(1)} ${Y1} L ${(X0 + w).toFixed(1)} ${(Y1 - h).toFixed(1)} Z" fill="${p.roche}"/>`
        + `<path d="M ${X0} ${Y1} L ${(X0 + w).toFixed(1)} ${(Y1 - h).toFixed(1)}" fill="none" stroke="${p.accent}" stroke-width="4" stroke-linecap="round"/>`
        + `<line x1="${X0}" y1="${Y1}" x2="${(X0 + w).toFixed(1)}" y2="${Y1}" stroke="${p.muted}" stroke-width="1.6"/>`
        + `<line x1="${(X0 + w).toFixed(1)}" y1="${Y1}" x2="${(X0 + w).toFixed(1)}" y2="${(Y1 - h).toFixed(1)}" stroke="${p.muted}" stroke-width="1.6" stroke-dasharray="6 6"/>`;
      /* l'arc de l'angle, au pied de la pente */
      const r = 58;
      corps += `<path d="M ${(X0 + r)} ${Y1} A ${r} ${r} 0 0 0 ${(X0 + r * Math.cos(deg * Math.PI / 180)).toFixed(1)} ${(Y1 - r * Math.sin(deg * Math.PI / 180)).toFixed(1)}"`
        + ` fill="none" stroke="${p.muted}" stroke-width="1.6"/>`
        + T(X0 + r + 40, Y1 - 16, 30, p.ink, `${Math.round(deg)}°`, { f:'Oswald', w:700, a:'start' })
        + T(X0 + r + 40, Y1 + 12, 15, p.muted, `SOIT ${pct} %`, { w:600, ls:2, a:'start' });
      const l = [];
      for (let i = 1; i <= 6; i++) {
        const raw = String(data['l' + i] || '').trim(); if (!raw) continue;
        const [lab, v] = raw.split('|').map(x => (x || '').trim());
        if (lab && v) l.push([lab, v]);
      }
      if (l.length) {
        /* Le pas est borné par la place RÉELLEMENT disponible au-dessus de la
           barre de valeurs (filet à 932), pas par un maximum arbitraire : à
           cinq lignes, la dernière passait dessous. */
        const y0 = 762, pasL = Math.min(40, (906 - y0) / Math.max(1, l.length - 1 || 1));
        l.forEach((rr, i) => {
          const y = y0 + i * pasL;
          corps += T(MX, y, 13, p.muted, esc(up(rr[0])), { w:600, ls:2.2, a:'start' })
            + T(PW - MX, y + 4, fit(rr[1], 380, 24, 0.58, 0, 13), p.ink, esc(rr[1]), { f:'Oswald', w:700, a:'end' });
          if (i < l.length - 1) corps += `<line x1="${MX}" y1="${(y + pasL/2 - 5).toFixed(1)}" x2="${PW-MX}" y2="${(y + pasL/2 - 5).toFixed(1)}" stroke="${p.line}" stroke-width="1.2"/>`;
        });
      }
      barre = stats(p, [[`${Math.round(deg)}°`, 'Pente'], [`${pct} %`, 'Soit'],
        [esc(String(data.exposition || '').trim()) || '—', 'Exposition']], 966);
      pied = 1032;
    }

    /* Le filigrane n'est posé que sur les modes où la place est vraiment
       vide : là où un dessin occupe déjà l'affiche, il ne ferait que salir. */
    const fili = ["descente","station","pente"].indexOf(mode) >= 0 ? filigrane(p) : '';
    const bas = [esc(up(data.joueur)), esc(up(data.equipe))].filter(Boolean).join(' · ');
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${PW} ${PH}" font-family="'Sora','Inter',sans-serif">
<rect width="${PW}" height="${PH}" fill="${p.bg}"/>
${T(cx, 84, 19, p.accent, esc(kicker), { w:700, ls:5 })}
${T(cx, 168, ts, p.ink, esc(titre), { f:'Oswald', w:700, ls:2 })}
${sous ? T(cx, 204, fit(sous, 660, 17, 0.66, 3.5, 11), p.muted, esc(sous), { w:600, ls:3.5 }) : ''}
${fili}
${corps}
${barre}
${pied && bas ? T(cx, pied, fit(bas, 690, 19, 0.60, 1, 12), p.ink, bas, { f:'Oswald', w:700, ls:1 }) : ''}
</svg>`;
  }

  window.SNSkDescente = { render, PALETTES, PISTES };
})();
